export default {
      id: "graph-centre-usage",
      viewBox: "0 0 150 162",
      url: __webpack_public_path__ + "svg/sprite.svg#graph-centre",
      toString: function () {
        return this.url;
      }
    }